import React from 'react'
import { motion, Variants } from 'framer-motion'

import heroSvg from '../../../assets/images/medilearn/medilearnhero.webp'
import Header from '../../organisms/Header/Header'

const topTextVariant: Variants = {
  hidden: {
    opacity: 0,
    y: 120,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 2,
      ease: [0.22, 1, 0.36, 1],
    },
  },
}

const bottomTextVariant: Variants = {
  hidden: {
    opacity: 0,
    y: -120,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 2,
      ease: [0.22, 1, 0.36, 1],
    },
  },
}

const HeroSectionMedilearn = () => {
  return (
    <section className="relative overflow-hidden 2xl:min-h-[1100px]">
      {/* Header */}
      <div className="relative z-50">
        <Header textColor="text-white" />
      </div>

      {/* Hero Content */}
      <div className="relative mx-auto flex min-h-[300px] w-full items-center justify-center px-5 md:min-h-[450px] lg:min-h-[600px] xl:min-h-[700px] 2xl:min-h-[1000px]">
        
        {/* TEXT */}
        <div className="relative z-10 flex w-full flex-col items-center leading-[1.20] md:leading-[0.85]">
          
          {/* TOP */}
          <motion.h1
            variants={topTextVariant}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.3 }}
            className="w-full text-center font-gilroy-extrabold text-[14.2vw] uppercase text-[#AABC79]"
          >
            MEDILEARN
          </motion.h1>

          {/* CENTER */}
          <h1 className="w-full text-center font-gilroy-extrabold text-[14.2vw] uppercase text-white">
            MEDILEARN
          </h1>

          {/* BOTTOM */}
          <motion.h1
            variants={bottomTextVariant}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.3 }}
            className="w-full text-center font-gilroy-extrabold text-[14.2vw] uppercase text-[#AABC79]"
          >
            MEDILEARN
          </motion.h1>

        </div>

        {/* CENTER IMAGE */}
        <motion.img
          src={heroSvg}
          alt="Medilearn Hero"
          animate={{
            rotate: 360,
          }}
          transition={{
            duration: 25,
            repeat: Infinity,
            ease: 'linear',
          }}
          className="
            absolute
            left-1/2
            top-1/2
            z-30
            w-[220px]
            -translate-x-1/2
            -translate-y-1/2
            md:w-[400px]
            lg:w-[500px]
            xl:w-[650px]
            2xl:w-[850px]
          "
        />

      </div>
    </section>
  )
}

export default HeroSectionMedilearn